import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { dateFormat } from '../../util/DateUtil';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    card: {
        width: 'fit-content'
    },
});

export default function PresencaProfile({ presenca }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <Grid container spacing={3}>
                    <Grid size={3}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Turma
                        </Typography>
                        <Typography variant="body1">
                            {presenca ? presenca.tdp.turma.descricao : ''}
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Disciplina
                        </Typography>
                        <Typography variant="body1">
                            {presenca ? presenca.tdp.disciplina.descricao : ''}
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Data
                        </Typography>
                        <Typography variant="body1">
                            {presenca ? dateFormat(presenca.data) : ''}
                        </Typography>
                    </Grid>
                </Grid>
                <CardActions>
                    <Button
                        component={Link}
                        to="/presenca"
                        color="secondary"
                        size="small"
                        variant="contained"
                    >
                        Trocar Presenca
                    </Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}